import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0263fd3d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "file-form mt10" }
const _hoisted_2 = { class: "mb10" }
const _hoisted_3 = { class: "file-input" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" ファイル選択 ")
const _hoisted_5 = { class: "filename" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("削除")
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode("削除")

import { computed, withDefaults } from "vue"
import { QuestionFile } from "@/types/question_file"
import { ElMessage } from "element-plus"
// 一度にアップロードするファイルサイズチェツク
interface Props {
  question_files?: QuestionFile[] | undefined;
  deleteIds?: number[] | undefined;
  modelValue: File[]; 

}
interface Emits {
  (e: "update:modelValue", _list: File[]): void;
  (e: "update:deleteIds", _ids: number[]): void;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    question_files: { type: [Array, null], required: false, default: undefined },
    deleteIds: { type: [Array, null], required: false, default: undefined },
    modelValue: { type: Array, required: true }
  },
  emits: ["update:modelValue", "update:deleteIds"],
  setup(__props: any, { emit }: { emit: ({
  (e: "update:modelValue", _list: File[]): void;
  (e: "update:deleteIds", _ids: number[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { question_files: QuestionFile[] | undefined, deleteIds: number[] | undefined, modelValue: File[] }
const maxSize = 5 * 1024 * 1024; // 5MB



const fileList = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)

})
const fileUploadSize = computed(() => {
  let sum = 0;
  for(let i = 0; i < fileList.value.length; i++) {
    sum += fileList.value[i].size
  }
  return sum
})
const deleteQuestionFileIds =  computed({
  get: () => props.deleteIds,
  set: (value) => emit('update:deleteIds', value)
})
const selectedFile = (e: Event) => {
  if (e.target instanceof HTMLInputElement) {
    e.preventDefault();
    let files = e.target.files;
    if (files && files[0]) {
      if (fileUploadSize.value + files[0].size > maxSize ) {
        ElMessage({
          showClose: true,
          message: "一度に添付出来るファイルは5MBまでです",
          type: 'error'
        });
        return
      }
      fileList.value.push(files[0]);
    }
  }
}
const addDeleteQuestionFileId = (id: number) => {
  deleteQuestionFileIds.value.push(id)
}
const removeFileList = (index: number) => {
  fileList.value.splice(index, 1);
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, [
        _createElementVNode("input", {
          style: {"display":"none"},
          onChange: selectedFile,
          type: "file",
          name: "file"
        }, null, 32),
        _hoisted_4
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fileList), (file, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "filelist",
        key: index
      }, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(file.name), 1),
        _createVNode(_component_el_button, {
          type: "text",
          onClick: ($event: any) => (removeFileList(index))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]))
    }), 128)),
    (__props.question_files)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.question_files, (file) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "filelist",
              key: file.id
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["filename", {deletefile: _unref(deleteQuestionFileIds).includes(file.id)}])
              }, [
                _createElementVNode("a", {
                  href: file.url,
                  target: "_blank"
                }, _toDisplayString(file.name), 9, _hoisted_8)
              ], 2),
              _createVNode(_component_el_button, {
                type: "text",
                disabled: _unref(deleteQuestionFileIds).includes(file.id),
                onClick: ($event: any) => (addDeleteQuestionFileId(file.id))
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})